import theme from '@berlitz/max-theme-berlitz'
import styled, { css } from 'styled-components'
import { lighten, darken } from 'polished'

const transition = `all 60ms ease-out`

export const ArrowIconWrapper = styled.span`
  display: inline-block;
  margin-left: 8px;
  transition: ${transition};
`

export const BannerPromoTitle = styled.span`
  font-weight: bold;
`
export const BannerWrapper = styled.div`
  display: flex;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? theme.section.backgroundColor[backgroundColor]
      : theme.section.backgroundColor.default};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: ${({ theme }) => theme.elevation.md};
  overflow: hidden;
  max-width: 100%;
  margin: 0 ${({ theme }) => theme.space.lg};
  flex-direction: column-reverse;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 960px; // size of 8 col grid
    margin: 0 auto;
  }
`

export const ImageColumn = styled.div`
  height: 0;
  padding-bottom: 56%;
  width: 100%;
  position: relative;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? darken(0.05, theme.section.backgroundColor[backgroundColor])
      : darken(0.05, theme.section.backgroundColor.default)};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 320px;
    height: 100%;
    padding-bottom: 0;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
`

export const DetailColumn = styled.div`
  padding: ${theme.space.lg};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${theme.space.xl};
    flex: 1;
  }
  ${({ backgroundColor }) =>
    backgroundColor === 'brandPrimary' &&
    css`
      [data-key='banner-promo-title'] > span {
        border: ${theme.space.xxxs} solid white;
        padding-left: ${theme.space.sm};
        padding-right: ${theme.space.sm};
        box-shadow: none;
        left: 0;
        background: transparent;
      }
    `}
`

export const BannerLink = styled.a`
  display: flex;
  text-decoration: none;
  transition: ${transition};
  width: 100%;
  flex-direction: column-reverse;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: space-between;
  }

  &:hover,
  &:focus,
  &:active {
    box-shadow: ${({ theme }) => theme.elevation.md};
    background-color: ${({ theme, backgroundColor }) =>
      backgroundColor
        ? lighten(0.05, theme.section.backgroundColor[backgroundColor])
        : lighten(0.05, theme.section.backgroundColor.default)};

    ${ArrowIconWrapper} {
      transform: translateX(2px);
    }
  }
`
